module.exports = __webpack_public_path__ + "static/img/IT.67c32b5f.jpg";